/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EServices.css';
import pans from './panStyle.scss';
import _ from 'lodash';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';
import CustomizedMap from './CustomizedMap';
import GrayPanel from '../../components/GrayPanel';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import cx from 'classnames';
import fetch from '../../core/fetch';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import { connect } from 'react-redux'
import { PersonalDataContainer, DecisionContainer } from '../../containers';
import agentConfig from './agent';
import RodoContent from '../../components/RodoContent';

import history from '../../core/history';
import u from './utils';
import { countAction } from '../../lib/utils';

const ModalAlert = ({ title, bodyText, disableButton, name, ...props }) =>
  <Modal {...props}>
    <Modal.Header className="bg-warning" closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {bodyText}
      <br /><br />
      {!disableButton ? (
        <Button className="btn btn-warning pull-right" onClick={() => props.onHide(name)}>Zamknij</Button>
      ) : null}
      <br /><br />
    </Modal.Body>
  </Modal>;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const InfoTypeDict = {
  adres: {
    label: 'Adres',
    editable: true,
  },
  cel: {
    label: 'Zaświadczenie jest mi niezbędne celem przedłożenia w',
    editable: true,
  },
};

const InfoTypeDict2 = {
  cel: {
    label: 'Zaświadczenie jest mi niezbędne celem przedłożenia w',
    editable: true,
  },
};

const typeOptions = [
  {
    label: 'o przeznaczeniu w miejscowym planie zagospodarowania przestrzennego',
    value: 'MPZP',
    state: 'rodzaj',
  },
  {
    label: ' o przeznaczeniu w studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    value: 'STUDIUM',
    state: 'rodzaj',
  },
];

const InfoTypeDict3 = {
  rodzaj: {
    label: 'Rodzaj zaświadczenia',
    editable: true,
    type: 'Select',
    options: typeOptions,
  },
  miejscowosc: {
    label: 'Miejscowość',
    editable: true,
  },
  ulica: {
    label: 'Ulica',
    editable: true,
  },
  cel: {
    label: 'Zaświadczenie jest mi niezbędne w celu',
    editable: true,
  },
};

const InfoTypeDict4 = {
  adres: {
    label: 'Adres',
    editable: true,
    type: 'textarea',
  },
  cel: {
    label: 'Wypis i wyrys niezbędny jest do',
    editable: true,
    type: 'textarea',
  },
};

const servicesWithoutTemplates = ['PrzebiegDrogiInfo', 'ZagospDzialkiInfo', 'NrIPowDzialkiInfo', 'WlasnoscDzialkiInfo', 'ZimoweUtrzymanieDrog',
  'ZabytekInfo', 'WodneInfo', 'OdpadyInfo', 'GESUTInfo', 'InformacjaSTUDIUM'];

class EServices extends React.Component {

  state = {
    info: {
      miejscowosc: null,
      ulica: null,
      numer: null,
      rodzaj: 'MPZP',
      adres: null,
      cel: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    setSelectDrogi: false,
    setSelectDzialki: true,
    acceptApplication: false,
    signDoc: false,
    acceptRODO: false,
    showError: false,
    showErrorMpzp: false,
    errors: {},
    errorTitle: '',
    errorText: '',
    docReason: '',
    differentReason: '',
    jobId: null,
    isWorking: false,
    progress: 0,
    mpzpValid: true,
    mpzpValidTitle: '',
    mpzpValidText: '',
    viewPortWidth: null,
    eserviceDistrict: null,
    redirect_to: null,
    cel: null,
  }

  onHide = () => this.setState({ showError: !this.state.showError });
  onHideMpzp = () => this.setState({ showErrorMpzp: !this.state.showErrorMpzp });
  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels })
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads })
  setSelectDrogi = (val, callback = null) => this.setState({ setSelectDrogi: val })
  setSelectDzialki = (val, callback = null) => this.setState({ setSelectDzialki: val })
  changeApplicationState = () => this.setState({ acceptApplication: !this.state.acceptApplication });
  changeSignDoc = () => this.setState({ signDoc: !this.state.signDoc });
  changeAcceptRODO = () => this.setState({ acceptRODO: !this.state.acceptRODO });

  componentWillMount() {
    // skierniewice
    if (this.props.district === "1063011") {
      if (this.props.serviceInfo.eservice.shortName === 'ZgloszenieLatarni') {
        this.setState({ redirect_to: 'http://mapa.inspire-hub.pl/#/skierniewice' });
      }
      else if (this.props.serviceInfo.eservice.shortName === 'WniosekMPZP/Studium' || this.props.serviceInfo.eservice.shortName === 'UwagaMPZP/Studium') {
        this.setState({ redirect_to: 'http://mapa.inspire-hub.pl/partycypacja/skierniewice' });
      }
    }
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      });
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      });
  };

  validateAcceptance = () => {
    if (this.props.isDisabled) {
      this.setState({ errorText: 'Przepraszamy. Usługa jest tymczasowo wyłączona.', errorTitle: 'Tymczasowa niedostępność usługi.', showError: true });
      return false;
    } else if ((this.props.serviceInfo.eservice.confirmText && !this.state.acceptApplication)) {
      this.setState({ errorText: 'Proszę o akceptację wymaganych pól. ', errorTitle: 'Błędnie wypełniony formularz', showError: true });
      return false;
    }
    else if (this.props.district === "1013024" && (this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP') && !this.state.acceptRODO) {
      this.setState({ errorText: 'Proszę o akceptację wymaganych pól. ', errorTitle: 'Błędnie wypełniony formularz', showError: true });
      return false;

    } else if (!this.state.mpzpValid) {
      this.setState({ mpzpValidText: 'Jedna lub więcej działek nie ma pokrycia w MPZP.', mpzpValidTitle: 'Błędnie wybrane działki', showErrorMpzp: true });
      return false;
    } else if (this.state.setSelectDzialki && this.state.selectedParcels.length <= 0) {
      this.setState({ errorText: 'Wymagane jest wybranie conajmniej jednej działki ewidencyjnej.', errorTitle: 'Błędnie wypełniony formularz.', showError: true });
      return false;
    } else if (this.state.setSelectDrogi && this.state.selectedRoads.length <= 0) {
      this.setState({ errorText: 'Wymagane jest wybranie conajmniej jedną drogę.', errorTitle: 'Błędnie wypełniony formularz.', showError: true });
      return false;
    }
    return true;
  }

  runService = () => {
    if (!this.validateAcceptance()) {
      return;
    }
    // /eservices/<string:teryt>/service/<string:serviceType>
    const url = `${process.env.API_URL}/eservices/${this.props.district}/service/${this.props.serviceInfo.eservice.shortName}`;
    let data = { dzialki: this.state.selectedParcels, drogi: this.state.selectedRoads, info: this.state.info, cel: this.state.cel };
    data['shortName'] = this.props.serviceInfo.eservice.shortName;
    data['info'] = { ...this.state.info };
    if (this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium') {
      data['docReason'] = this.state.docReason !== 'inne...' ? this.state.docReason : this.state.differentReason;
    }
    if (this.props.serviceInfo.eservice.requiresUserInfo) {
      data['userID'] = this.props.serviceInfo.user.ID;
      data['userType'] = this.props.serviceInfo.user.userType;
      data['dane_wnioskodawcy'] = `${this.props.serviceInfo.user.FirstName} ${this.props.serviceInfo.user.LastName}<br />
                                  ul. ${this.props.serviceInfo.user.AddressStreet} ${this.props.serviceInfo.user.AddressNumber}/${this.props.serviceInfo.user.AddressFlat}<br />
                                  ${this.props.serviceInfo.user.AddressZipCode} ${this.props.serviceInfo.user.AddressCity}`
    }
    const odp = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(r => {
        if (r.status === 200) {
          return r.json();
        }
        throw new Error('Blad');
      })
      .then(resp => {
        // returnsDoc: true,
        if (this.props.serviceInfo.eservice.returnsDoc) {
          window.location.href = `${process.env.API_URL}/eservices/${this.props.district}/getDoc/${resp.fileName}`;
          countAction(this.props.prefix, 4, 2, this.props.serviceInfo.eservice.id);
        } else {
          this.setState({ jobId: resp.message, isWorking: true }, () => this.getJobStatus());
        }
      })
      .catch(err => {
        // TODO: create modal info, with message: Błąd po stronie serwera wróc za 10 min
        console.info('HABIBI07: err', err);
      });
  }

  onJobFinish = (resp) => {
    if (this.props.serviceInfo.user.userType === 'local') {
      window.location.href = `/eservices/eserviceSummary/${this.state.jobId}`;
    } else {
      window.location.href = `/eservices/eserviceSummary/${this.state.jobId}?customerId=${this.props.query.customerId}`;
    }
    // if (this.state.signDoc) {
    //   // TODO: filter districts
    //   // Redirects to signing python endpoint
    //   window.location.href = `${process.env.API_URL}/eservices/signDoc/${this.state.jobId}`;
    // } else {
    //   if (this.props.serviceInfo.user.userType === 'local') {
    //     window.location.href = `/eservices/paymentStatus/${this.state.jobId}`;
    //   } else {
    //     window.location.href = `/eservices/paymentStatus/${this.state.jobId}?customerId=${this.props.query.customerId}`;
    //   }
    // }
  }

  onJobFailed = () => this.setState({
    isWorking: false,
    errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
    errorTitle: 'Tymczasowa niedostępność usługi.',
    showError: true,
  });

  getJobStatus = () => fetch(`${process.env.API_URL}/service/status/${this.state.jobId}`, { method: 'GET' })
    .then(r => r.json())
    .then(resp => {
      this.setState(
        {
          jobStatus: resp, progress: this.state.progress !== 99 ? this.state.progress + 0.5 : 99, modalBody: <div>
            <ProgressBar active now={this.state.progress} label={`${this.state.progress}%`} />
            <p>
              Trwa generowanie Twojego dokumentu, w zależności od złożoności dokumentu generowanie może trwać od 30s do około 2 minut.
      </p>
          </div>, modalText: 'Generowanie dokumentu...'
        },
        () => {
          if (resp.status === 'started' || resp.status === 'queued') {
            setTimeout(this.getJobStatus, 50); //: (resp.status === 'finished') ? this.onJobFinish(resp) : this.setState({ isWorking: false })
          }
          if (resp.status === 'finished') {
            this.onJobFinish(resp);
          }
          if (resp.status === 'failed') {
            this.onJobFailed()
          }

        })
    }
    );
  handleRedirect = () => {
    const redirect = '/urzad';
    window.location.href = redirect;
  }

  mpzpValidator = (valid) => {
    if (valid !== this.state.mpzpValid) {
      this.setState({ mpzpValid: valid });
    }
  }

  render() {
    if (this.state.redirect_to) {
      window.location.replace(this.state.redirect_to);
      return (
        <div className={s.root}>
          <div className={s.container}>
            <center>
              <GrayPanel title="" bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px' }}><img role="presentation" src={waiting} /></GrayPanel>
            </center>
          </div>
        </div>
      );
    }

    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className="row mobile-row" style={{ marginTop: '15px' }}>
            <h3 style={{ textAlign: 'center' }}>
              {this.props.serviceInfo.eservice.title}
            </h3>
            {this.props.serviceInfo.eservice.requiresUserInfo && this.props.serviceInfo.user ?
              <PersonalDataContainer userData={this.props.serviceInfo.user} />
               : null}
            {this.props.serviceInfo.eservice.enableMap &&
              <GrayPanel title="Wybierz działki">
                <div className="help-desc">
                  W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden z dwóch dostępnych sposobów wyboru działki:<br />
                  <ol>
                    <li> Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer działki. W celu dodania kolejnej działki należy powtórzyć czynność.</li>
                    <li>Wskazać działkę w oknie mapy wykorzystując przycisk <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.</li>
                  </ol>
                  Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku <samp>"Odznacz wszystko"</samp>.
                </div>
                <CustomizedMap
                  serviceType={this.props.serviceInfo.eservice.shortName}
                  setParcels={this.setParcels}
                  setRoads={this.setRoads}
                  setSelectDzialki={this.setSelectDzialki}
                  setSelectDrogi={this.setSelectDrogi}
                  selectedParcels={this.state.selectedParcels}
                  selectedRoads={this.state.selectedRoads}
                  obreby={this.props.serviceInfo.precints}
                  district={this.props.districts[this.props.prefix]}
                  prefix={this.props.prefix}
                  mapState={this.props.mapstates[0]}
                  settings={this.props.serviceInfo.eservice.mapConfig}
                  mpzpValidator={this.mpzpValidator}
                  dokumentType={this.props.serviceInfo.eservice}
                />
                {(this.props.district === "1013024" && (this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP')) ?
                  <div className="help-desc">
                    <div className={s.subtitle}>
                      <input
                        name="isDefault"
                        type="checkbox"
                        value={this.state.acceptRODO}
                        onChange={this.changeAcceptRODO}
                      /> <gwiazda style={{ color: 'red' }}>*</gwiazda>Zgoda na przetwarzanie danych
                      <u.RODOBialaRawska />
                    </div>
                    <div className={s.subtitle} style={{ color: 'red' }}>
                      * - Pole obowiązkowe
                  </div></div>
                  : null}
              </GrayPanel>
            }
            {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
              <DecisionContainer
                title={'Pełnomocnik'}
                data={this.state.info}
                errors={this.state.errors}
                formDict={agentConfig.agentInfoDict}
                onChange={e => this.onChange(e, 'info')}
                onChangeSelect={e => this.onChangeSelect(e, 'info')}
              >
                <br />
                <p style={{ color: 'red' }}>
                W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
                </p>
              </DecisionContainer> : null }
            {this.state.info.agentAdd === 'TAK' ?
              <DecisionContainer
                title={'Dane identyfikacyjne pełnomocnika'}
                data={this.state.info}
                errors={this.state.errors}
                formDict={agentConfig.agentDict}
                onChange={e => this.onChange(e, 'info')}
              /> : null }
            {this.state.eserviceDistrict && this.state.eserviceDistrict.custom ?
              <GrayPanel title="Dane o działce: ">
                <div className="row mobile-row" style={rowStyle}>
                  <div className={leftCol} />
                  <div className={labelCol}>
                    <label style={labelStyle}>Ulica</label>
                  </div>
                  <div className={inputCol}>
                    <input className="form-control" onChange={(e) => this.setState({ info: { ...this.state.info, ulica: e.target.value } })} />
                  </div>
                  <div className={rightCol} />
                </div>

                <div className="row mobile-row" style={rowStyle}>
                  <div className={leftCol} />
                  <div className={labelCol}>
                    <label style={labelStyle}>Numer</label>
                  </div>
                  <div className={inputCol}>
                    <input className="form-control" onChange={(e) => this.setState({ info: { ...this.state.info, numer: e.target.value } })} />
                  </div>
                  <div className={rightCol} />
                </div>
              </GrayPanel> : null}
            {/* {this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP' || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium' &&
              <GrayPanel title="Cel zaświadczenia">
                <div className="row mobile-row">
                  <div className={leftCol} />
                  <div className={labelCol}>
                    <label htmlFor="dzialki" style={labelStyle} >Cel</label>
                    {this.state.docReason === 'inne...' && <div><label htmlFor="dzialki" style={labelStyle} >Jaki</label></div>}
                  </div>
                  <div className={inputCol}>
                    <select value={this.state.docReason} className="form-control" onChange={(e) => this.setState({ docReason: e.target.value })}>
                      <option>przedłożenia w Kancelarii Notarialnej</option>
                      <option>przedłożenia w Urzędzie Skarbowym</option>
                      <option>przedłożenia w operacie szacunkowym</option>
                      <option>podziału nieruchomości</option>
                      <option>inne...</option>
                    </select>
                    {this.state.docReason === 'inne...' && <div><input className="form-control" type="text" onChange={(e) => this.setState({ differentReason: e.target.value })} /></div>}
                  </div>
                  <div className={rightCol} />
                </div>
              </GrayPanel>
            } */}
            {(this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieOPrzeznaczeniu') ?
              <DecisionContainer
                title={'Dodatkowe informacje'}
                data={this.state.info}
                errors={this.state.errors}
                formDict={InfoTypeDict3}
                onChange={e => this.onChange(e, 'info')}
                onChangeSelect={e => this.onChangeSelect(e, 'info')}
              /> : null
            }
            {((this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP')
              && this.props.district === '604011') ?
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict}
                  onChange={e => this.onChange(e, 'info')}
                /> : null
            }
            {((this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium')
              && this.props.district === '604011') ?
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict2}
                  onChange={e => this.onChange(e, 'info')}
                /> : null
            }
            {((this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp')
              && this.props.district === '1608033') ?
                <DecisionContainer
                  title={'Dodatkowe informacje'}
                  data={this.state.info}
                  errors={this.state.errors}
                  formDict={InfoTypeDict4}
                  onChange={e => this.onChange(e, 'info')}
                /> : null
            }
            {((this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieMPZP'
              || this.props.serviceInfo.eservice.shortName === 'ZaswiadczenieStudium'
              || this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZeStudium'
              || this.props.serviceInfo.eservice.shortName === 'WypisIWyrysZMpzp')
              && this.props.district === '215022') ?
                <GrayPanel title="Cel wydania dokumentu">
                  <div className="row mobile-row">
                    <div className={leftCol} />
                    <div className={labelCol}>
                      <label htmlFor="dzialki" style={labelStyle}>
                        Cel
                      </label>
                    </div>
                    <div className={inputCol}>
                      <div><input className="form-control" type="text" onChange={(e) => this.setState({ cel: e.target.value })} /></div>
                    </div>
                    <div className={rightCol} />
                  </div>
                </GrayPanel> : null
            }
            {(this.props.serviceInfo.eservice.signWithEPUAP || this.props.serviceInfo.eservice.confirmText) &&
              <GrayPanel title="Akceptuj">
                {this.props.serviceInfo.eservice.signWithEPUAP &&
                  <div className={s.subtitle}>
                    <input
                      name="isDefault"
                      type="checkbox"
                      value={this.state.signDoc}
                      onChange={this.changeSignDoc}
                    /> &nbsp;&nbsp;&nbsp;
                    Podpisz dokument podpisem elektronicznym ePUAP</div>
                }
                {this.props.serviceInfo.eservice.confirmText &&
                  <div className={s.subtitle}>
                    <input
                      name="isDefault"
                      type="checkbox"
                      value={this.state.acceptApplication}
                      onChange={this.changeApplicationState}
                    /> &nbsp;&nbsp;&nbsp;
                    <gwiazda style={{ color: 'red' }}>*</gwiazda> {this.props.serviceInfo.eservice.confirmText}
                  </div>
                }
                <div className={s.subtitle} style={{ color: 'red' }}>
                  * - Pole obowiązkowe
                </div>
              </GrayPanel>
            }
            <RodoContent prefix={this.props.prefix} />
            <div className="row mobile-row">
              <div className="col-sm-12">
                <PowrotDoListyEuslug position='left' prefix={this.props.prefix} />
                {(!servicesWithoutTemplates.includes(this.props.serviceInfo.eservice.shortName)) ?
                  <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} /> :
                  null }
                <button
                  type="submit-lg"
                  className={this.props.isDisabled ? "btn btn-primary disabled" : "btn btn-primary"}
                  style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                  onClick={() => this.setState({ progress: 0 }, () => this.runService())}
                >
                  Uruchom
                </button>
                <button
                  type="submit-lg"
                  className="btn btn-default"
                  style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                  onClick={history.goBack}
                >
                  Anuluj
                </button>
              </div>
            </div>
          </div>
        </div>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={this.state.mpzpValidTitle}
          bodyText={this.state.mpzpValidText}
          show={this.state.showErrorMpzp}
          name="mpzpErrorModal"
          onHide={this.onHideMpzp}
        />
        <ModalAlert
          title={this.state.modalText}
          bodyText={this.state.modalBody}
          show={this.state.isWorking}
          name="isWorkingModal"
          onHide={this.onHide}
          disableButton
        />
      </div>
    );
  }
}

EServices.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
};

export default withStyles(pans)(withStyles(s)(connect(mapState, mapDispatch)(EServices)));



// WEBPACK FOOTER //
// src/routes/eservices/EServices.js